module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAPCAYAAAA2yOUNAAAAjklEQVQokY3SuwqDQBCF4ZMEMRc7X1jS5g0kpEggoGUKCUQwD5RqU1n9VuI4qHhguw925uwK0MTZABcgANkcyBkSPNgBN8Z5eXB34AucLHg6UANHQAIioHTg3YMeXR2ogL2dVUBrwA9I/MZbSQ8NSSUVkmLZLMx0sNfNbfex2y311NieVje++u38L/gD5w4m0rCESwH+cAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/modules/fronend/images/arrow-left.png
// module id = ./src/assets/modules/fronend/images/arrow-left.png
// module chunks = 2 3